var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { display: "block" }, attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("choose-size")))]),
      _c("w-card-content", [
        _c("div", { staticClass: "product-name" }, [
          _vm._v(_vm._s(_vm.product.Sku) + " - " + _vm._s(_vm.product.Name)),
        ]),
        _c(
          "div",
          { staticClass: "pad" },
          _vm._l(_vm.entries, function (entry) {
            return _c(
              "button",
              {
                key: entry.ID,
                staticClass: "button",
                on: {
                  click: function ($event) {
                    return _vm.select(entry)
                  },
                },
              },
              [_vm._v(_vm._s(entry.Name))]
            )
          }),
          0
        ),
      ]),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.select(null)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("no-size")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }